exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-padding{\r\n    padding-top:8px;\r\n    padding-right:32px;\r\n    padding-bottom:18px;\r\n    padding-left:25px;\r\n}\r\n\r\n.panel-info {\r\n    box-shadow: 1px 4px 7px 0px #675d5d;\r\n    border:none;\r\n}\r\n\r\n.loadingClass {\r\n    font-size: 70px;\r\n    margin-top: 30%;\r\n    margin-left: 40%;\r\n    color:#2035ac\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/landing-modules/landing-modules.component.css
// module id = ../../../../../src/app/landing-modules/landing-modules.component.css
// module chunks = 2